import React from 'react'
import Social from './Social'
import {i} from '../i'

export default class Footer extends React.Component {
  state={}
  render() {
  return (
    <footer className="site-footer text-light">
      <div className="container">
        <div className="site-footer-inner">
          <div className="brand footer-brand">
            <a href={i.url} target="_blank">
              <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <title>{i.name}</title>
                <defs>
                  <path d="M32 16H16v16H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v14z" id="logo-gradient-footer-a"/>
                  <linearGradient x1="50%" y1="50%" y2="100%" id="logo-gradient-footer-b">
                    <stop stopColor="#FFF" stopOpacity="0" offset="0%"/>
                    <stop stopColor="#FFF" offset="100%"/>
                  </linearGradient>
                </defs>
                <g fill="none" fillRule="evenodd">
                  <mask id="logo-gradient-footer-c" fill="#fff">
                    <use href="#logo-gradient-footer-a"/>
                  </mask>
                  <use fillOpacity=".32" fill="#FFF" href="#logo-gradient-footer-a"/>
                  <path fill="url(#logo-gradient-footer-b)" mask="url(#logo-gradient-footer-c)" d="M-16-16h32v32h-32z"/>
                </g>
              </svg>
            </a>
          </div>
          <ul className="footer-links list-reset">
            <li>
              <a href={i.url} target="_blank">Contact</a>
            </li>
            <li>
              <a href={i.url} target="_blank">About us</a>
            </li>
            {/*
              <li>
                <a href="">FAQ''s</a>
              </li>
              false&&
              <li>
                <a href="">Support</a>
              </li>
            */}
          </ul>
          <Social />
          <div className="footer-copyright">&copy; {(new Date()).getFullYear()} {i.by}, all rights reserved</div>
        </div>
      </div>
    </footer>
  )
  }
}



// WEBPACK FOOTER //
// ./src/component/Footer.js